import React from "react";
import './Home.css'
import Login from "../login/Login";
import Login_plasma_lms from "../login/login_plasma_lms";
const Home = () => {
  return (
    <div className="home-parent">
      <div className="home-container">
        {/* <Login /> */}
        <Login_plasma_lms />
      </div>
    </div>
  );
};

export default Home;
